import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SectionHeader } from '../components/ui/SectionHeader';
import { ChevronLeft } from 'lucide-react';

export const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="py-12">
      <div className="container mx-auto px-6 max-w-4xl">
        <button 
            onClick={() => navigate(-1)}
            className="group flex items-center gap-2 mb-8 text-gray-300 hover:text-white transition-colors"
        >
            <ChevronLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
            <span className="text-xs font-bold uppercase tracking-widest">Back</span>
        </button>
        
        <div className="bg-black/60 backdrop-blur-md border border-white/10 p-8 md:p-12">
            <SectionHeader subtitle="Legal" title="Privacy Policy" />

            <div className="prose prose-invert max-w-none prose-p:text-slate-300 prose-headings:text-white prose-a:text-astral-purple prose-strong:text-white">
                <p>Last updated: {new Date().toLocaleDateString()}</p>
                
                <h2>1. Introduction</h2>
                <p>
                    AstralVibe ("we", "our", "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website astralvibe.art. Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the site.
                </p>
                
                <h2>2. Collection of Your Information</h2>
                <p>
                    We may collect information about you in a variety of ways. The information we may collect on the Site includes:
                </p>
                <ul>
                    <li>
                        <strong>Personal Data:</strong> Personally identifiable information, such as your name, email address, and telephone number, that you voluntarily give to us when you fill out a contact, demo submission, booking, or service request form.
                    </li>
                    <li>
                        <strong>Derivative Data:</strong> Information our servers automatically collect when you access the Site, such as your IP address, your browser type, your operating system, your access times, and the pages you have viewed directly before and after accessing the Site.
                    </li>
                     <li>
                        <strong>Cookie Data:</strong> We may use cookies to help customize the Site and improve your experience. For more information on how we use cookies, please refer to our <Link to="/cookie-policy" className="text-astral-purple hover:underline">Cookie Policy</Link>.
                    </li>
                </ul>

                <h2>3. Use of Your Information</h2>
                <p>
                    Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you via the Site to:
                </p>
                 <ul>
                    <li>Respond to your inquiries, booking requests, demo submissions, or service requests.</li>
                    <li>Monitor and analyze usage and trends to improve your experience with the Site.</li>
                    <li>Prevent fraudulent transactions, monitor against theft, and protect against criminal activity.</li>
                    <li>Compile anonymous statistical data and analysis for use internally.</li>
                </ul>

                <h2>4. Disclosure of Your Information</h2>
                <p>
                    We do not share, sell, rent or trade your information with third parties for their commercial purposes. We may share information we have collected about you in certain situations, such as with our third-party service providers who perform services for us or on our behalf, including data analysis and email delivery.
                </p>
                
                <h2>5. Security of Your Information</h2>
                <p>
                    We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.
                </p>

                <h2>6. Your Rights (GDPR)</h2>
                <p>
                    If you are a resident of the European Economic Area (EEA), you have certain data protection rights. We aim to take reasonable steps to allow you to correct, amend, delete, or limit the use of your Personal Data. You have the right to:
                </p>
                <ul>
                    <li>Access, update or delete the information we have on you.</li>
                    <li>Rectification.</li>
                    <li>Object to processing.</li>
                    <li>Data portability.</li>
                    <li>Withdraw consent.</li>
                </ul>
                <p>
                    To exercise these rights, please contact us using the contact information below.
                </p>
                
                <h2>7. Contact Us</h2>
                <p>
                    If you have questions or comments about this Privacy Policy, please contact us at:<br/>
                    <strong>AstralVibe</strong><br/>
                    <strong>Email:</strong> <a href="mailto:privacy@astralvibe.art">privacy@astralvibe.art</a>
                </p>
            </div>
        </div>
      </div>
    </div>
  );
};